import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { SITE_URL } from "src/utils/chat";

// Slim top bar: menu toggle on small screens, a link back to the public
// site, and the host's account menu.
const DashboardNavbar = ({ onMobileNavOpen }) => {
  const host = useSelector((state) => state.edit_host?.host);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const user = host?.User_ID;
  const name = [user?.first_name, user?.last_name].filter(Boolean).join(" ") || user?.username || "Host";

  useEffect(() => {
    const close = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const logout = () => {
    localStorage.clear();
    window.location.replace("/");
  };

  return (
    <header className="hd-topbar">
      <button type="button" className="hd-icon-btn hd-menu-toggle" onClick={onMobileNavOpen} aria-label="Open menu">
        <i className="fas fa-bars" />
      </button>
      <div className="hd-topbar-spacer" />
      <a className="hd-topbar-link" href={SITE_URL} target="_blank" rel="noopener noreferrer">
        <i className="fas fa-external-link-alt" /> <span>View tubayo.com</span>
      </a>
      <div className="hd-account" ref={menuRef}>
        <button type="button" className="hd-account-btn" onClick={() => setOpen(!open)}>
          {user?.photo ? (
            <img src={user.photo} alt="" />
          ) : (
            <span className="hd-avatar-initial">{name.charAt(0).toUpperCase()}</span>
          )}
          <span className="hd-account-name">{name}</span>
          <i className="fas fa-chevron-down" />
        </button>
        {open && (
          <div className="hd-menu hd-menu-right">
            <Link to="/app/account" className="hd-menu-item" onClick={() => setOpen(false)}>
              <i className="far fa-user-circle" /> Account
            </Link>
            <button type="button" className="hd-menu-item" onClick={logout}>
              <i className="fas fa-sign-out-alt" /> Log out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func,
};

export default DashboardNavbar;
